export const EDIT_VOICE_SETTINGS_MODAL_STYLES = {
  bottom: '100%',
  left: '-1px',
  transform: 'none',
  width: 'calc(100% + 2px)',
};
